var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14828_20763)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55 13V5.944H8.95V13H7.55ZM8.264 4.614C7.99333 4.614 7.76933 4.53 7.592 4.362C7.424 4.194 7.34 3.97933 7.34 3.718C7.34 3.466 7.424 3.26067 7.592 3.102C7.76933 2.934 7.99333 2.85 8.264 2.85C8.52533 2.85 8.74467 2.934 8.922 3.102C9.09933 3.26067 9.188 3.466 9.188 3.718C9.188 3.97933 9.09933 4.194 8.922 4.362C8.74467 4.53 8.52533 4.614 8.264 4.614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14828_20763"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.af06eab4a4a9011a051269638dffa7da.svg";
export { ForwardRef as ReactComponent };